// extracted by mini-css-extract-plugin
export default {"account-menu__user-name":"accountMenu_account-menu__user-name__APwk+","account-menu__header":"accountMenu_account-menu__header__4t6Xh"};